<template>
  <div class="container">
    <div
      id="page1-div"
      class="container interline border page-container"
    >
      <div class="col-12 p-5">
        <div class="col-12 p-2 border border-dark">
          <div class="row">
            <div class="col-8 text-right">
              <u class="ft15Black">Teléfonos de Asistencia</u>
              <br /><br />
              <div class="col-12 text-left">
                <span class="ft12">
                  Número de Crédito:
                  <span v-bind:class="{ marca: data.showMarca }">
                    {{ data.No_Operacion_Cliente }}
                  </span>
                  <br /><br />
                  Conmutador:
                  <span class="ft12Black">(33) 1078-2828</span>
                  <br /><br />
                  Saldos y Pagos: (33) 1078-2828 Ext. 1117, 1118 y 1120.
                </span>
              </div>
            </div>
            <div class="col-4 text-center">
              <img src="../Logo-GPI.png" class="rounded" width="100px" />
            </div>
          </div>
          <div class="row pl-3 pt-3">
            <div class="col-12">
              <span class="ft12">
                Atención Renovación Seguro Automotriz: (33) 1078-2828 Ext.1127.
                Cel. (33) 18481249.
                <br /><br />
                Correo: seguros@gpiautocomercial.com.mx
                <br /><br />
                Cartas Facturas: operaciones@gpiautocomercial.com.mx
                <br /><br />
                Atención a Clientes: (33) 1153-5435.
                <br /><br />
                Atención Siniestros / Robos: Favor de comunicarse al teléfono de
                atención al cliente de la compañía aseguradora elegida en el
                financiamiento.
                <br />
                En caso de asesoría Administrativa o Seguimiento del estatus
                favor de comunicarse (33) 1078-2828 Ext.1127, Horario de
                Atención 9:00 A.M. a 6:00 P.M de Lunes a Viernes.
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "IntruccionPAgoTErceros",
  data() {
    return {};
  },
  validations() {
    return {};
  },
  props: {
    data: {
      type: Object
    }
  },
  methods: {},
  created() {
    window.scrollTo(0, 0);
  }
};
</script>
<style type="text/scss">
@import "../style.scss";
</style>



// WEBPACK FOOTER //
// src/views/Contratos/Caratura1/ServicioGpiTrad.vue